<script>
import { deleteSubPackage } from "../../../api/services/sub-package.service";
export default {
  props: {
    visible: Boolean,
    closeable: Boolean,
    subpackageID: String,
  },
  data() {
    return {
      subpackageId: null,
      isDeletingProcessing: false,
      isDeleteSuccess: false,
      isDeleteFailed: false,
      isFormSubmited: false,
    };
  },
  computed: {
    showModal: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  mounted() {
    this.subpackageId = this.subpackageID;
  },
  methods: {
    async clickDeleteSubpackage() {
      this.isFormSubmited = true;
      this.isDeletingProcessing = true;
      let deleteSubpackageSuccess = await deleteSubPackage(this.subpackageId);

      if (deleteSubpackageSuccess) {
        this.isDeletingProcessing = false;
        this.isDeleteSuccess = true;
      } else if (!deleteSubpackageSuccess) {
        this.isDeletingProcessing = false;
        this.isDeleteFailed = true;
      }
    },
    clickCloseButton() {
      this.$emit("reload");
    },
  },
};
</script>

<template>
  <!-- Delete Dataset Model -->
  <b-modal
    v-model="showModal"
    centered
    hide-footer
    :title="this.$i18n.t('subpackages.deleteSubpackage.title')"
    no-close-on-backdrop
    no-close-on-esc
    header-close-content
  >
    <div class="row mt-3" v-if="!isFormSubmited">
      <div class="col-lg-12 text-lg-center">
        <b-img
          class="mb-2"
          alt=""
          :src="require('@/assets/images/Delete Subpackage.png')"
          style="height: 200px"
        ></b-img>
        <div class="d-flex justify-content-center mb-3">
          <p>
            {{ $t("subpackages.deleteSubpackage.question") }}
            <br />
            {{ $t("subpackages.deleteSubpackage.information") }}
          </p>
        </div>
        <div class="pb-2 col-md-12 text-lg-center">
          <b-button variant="light" @click="showModal = false">{{
            $t("general.buttons.cancel")
          }}</b-button>
          <b-button
            variant="danger"
            @click="clickDeleteSubpackage"
            class="ml-2"
            >{{ $t("general.buttons.delete") }}</b-button
          >
        </div>
      </div>
    </div>
    <div class="row">
      <!-- Deleting Processing -->
      <div class="col-md-12 text-center" v-if="isDeletingProcessing">
        <b-spinner
          style="width: 5rem; height: 5rem"
          class="m-2"
          variant="warning"
          role="status"
        ></b-spinner>
        <h5 class="mt-3">
          {{ $t("subpackages.deleteSubpackage.deleteProcessingTitle") }}
        </h5>
        <p class="mt-3">
          {{ $t("subpackages.deleteSubpackage.deleteProcessingText") }}
        </p>
      </div>
      <!-- Delete Success -->
      <div class="col-md-12 text-center" v-if="isDeleteSuccess">
        <i class="bx bx-check-circle bx-tada text-success display-1"></i>
        <h5 class="mt-3">
          {{ $t("subpackages.deleteSubpackage.deleteSuccesTitle") }}
        </h5>
        <p class="mt-3 mb-3">
          {{ $t("subpackages.deleteSubpackage.deleteSuccessText") }}
        </p>
        <b-button variant="warning" @click="clickCloseButton()">
          <i class="bx bxs-x-circle mr-1"></i>
          {{ $t("general.buttons.close") }}</b-button
        >
      </div>
      <!-- Delete Failed -->
      <div class="col-md-12 text-center" v-if="isDeleteFailed">
        <i class="bx bx-x-circle bx-tada text-danger display-1"></i>
        <div class="mt-3">
          {{ $t("subpackages.deleteSubpackage.deleteFailedTitle") }}
        </div>
        <p class="mt-3">
          {{ $t("subpackages.deleteSubpackage.deleteFailedText") }}
        </p>
      </div>
    </div>
  </b-modal>
</template>